export const performanceRouteNames = {
   TASKS: 'tasks',
   FUNCTIONS: 'functions',
};
